import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import queryString from 'query-string';
import firebase from '../../../config/firebase.config';
import AppLogo from '../../../assets/img/brand/logo.jpeg';
import { authActionTypes } from '@store/Auth/Auth.actionTypes';

const ERROR_MESSAGES = {
  'auth/expired-action-code':
    'This verification link has expired. Please sign up again.',
  'auth/invalid-action-code': 'This link is invalid or has already been used.',
};

const VerifyEmail = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { oobCode } = queryString.parse(location.search);

  const [status, setStatus] = useState('verifying');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!oobCode) {
      setErrorMessage('Invalid verification link. Please check your email.');
      setStatus('error');
      return;
    }

    (async () => {
      try {
        await firebase.auth().applyActionCode(oobCode);

        const currentUser = firebase.auth().currentUser;
        if (currentUser) {
          await currentUser.reload();
          dispatch({ type: authActionTypes.LOAD_CURRENT_ACCOUNT });
        } else {
          setStatus('success');
        }
      } catch (error) {
        setErrorMessage(
          ERROR_MESSAGES[error.code] ||
            'Verification failed. The link may have expired or already been used.'
        );
        setStatus('error');
      }
    })();
  }, [oobCode, dispatch]);

  return (
    <Col lg="5" md="7">
      <Card className="bg-secondary shadow border-0">
        <CardHeader className="bg-transparent pb-2 border-0">
          <div className="text-center">
            <img className="auth-app-logo" src={AppLogo} alt="Prodaff" />
          </div>
          <div className="text-muted text-center mt-2 mb-3">
            {status === 'verifying' && (
              <>
                <h2>Verifying your email</h2>
                <small>Please wait a moment...</small>
              </>
            )}
            {status === 'success' && (
              <>
                <h2>Email verified</h2>
                <small>
                  Your account is confirmed. Sign in to get started.
                </small>
              </>
            )}
            {status === 'error' && (
              <>
                <h2>Verification failed</h2>
                <small>{errorMessage}</small>
              </>
            )}
          </div>
        </CardHeader>
        {(status === 'success' || status === 'error') && (
          <CardBody className="px-lg-5 py-lg-4 text-center">
            <Link to="/auth/login" className="btn btn-primary">
              Sign In
            </Link>
          </CardBody>
        )}
      </Card>
      {status === 'error' && (
        <div className="pb-5 pt-2 text-center">
          <small className="text-white">
            Need a new link?{' '}
            <Link className="font-weight-bold text-white" to="/auth/sign-up">
              Sign up again
            </Link>
          </small>
        </div>
      )}
    </Col>
  );
};

export default VerifyEmail;
